const projects = [
  {
    id: 1,
    title: 'Limey',
    tech: 'React, Node.js, Firebase',
    description: [
      'A smart shopping list that predicts future purchase dates based on user buying habits. Add items, check off items as you buy, and share your list with others to edit together.',
    ],
    image: 'limey.gif',
    link: 'https://limey-list.web.app/',
  },
  {
    id: 2,
    title: 'Tomato',
    tech: 'React Native, Expo, Xcode, React Hooks, Google Maps API, Firebase, Firestore',
    description: [
      'A social media application that allows you to drop a pin to your precise location with a message, a photo, or a video to broadcast events to your friends and the world.',
    ],
    image: 'tomato.gif',
    link: 'https://github.com/team-tomatoes/tomato',
  },
  {
    id: 3,
    title: 'Pottery Studio',
    tech: 'React, Redux, Node.js, Express, Sequelize',
    description: [
      'A mock e-commerce website in which users can purchase pottery goods. Includes a home page, shop view, single product view, and a functional cart/checkout page. An admin user has the ability to login, edit products, and delete products.',
    ],
    image: 'pottery.gif',
    link: 'https://pottery-studio.vercel.app/',
  },
];

export default projects;
